'use strict';

const createWidgetFactory = require('components-framework/widget/create_widget_factory');
const BaseView = require('components-framework/view/base.view');
const ShoppingCart = require('od-modules/cart/cart');

const getFirstSeatMapItemQuantity = ([{quantity = 0} = {}] = []) => quantity;
const getSeatMapQuantity = () => getFirstSeatMapItemQuantity(ShoppingCart.take.seats());

const filterEmpty = (items = []) => items.filter(({concept = ''}) => concept.trim().length > 0);
const getInsurances = () => filterEmpty(ShoppingCart.take.insurances());
const getFareRules = () => filterEmpty(ShoppingCart.take.fareRules());
const getServiceOptions = () => filterEmpty(ShoppingCart.take.serviceOptions());
const getFastTrack = () => ShoppingCart.take.fastTrack();

const isCollectionEmpty = (collection = []) => collection.length === 0;
const isInsurancesEmpty = () => isCollectionEmpty(getInsurances());
const serviceOptionsEmpty = () => isCollectionEmpty(getServiceOptions());
const fareRulesEmpty = () => isCollectionEmpty(getFareRules());
const isSeatMapEmpty = () => getSeatMapQuantity() === 0;
const isFastTrackEmpty = () => isCollectionEmpty(getFastTrack());
const isEmpty = () => isInsurancesEmpty() && serviceOptionsEmpty() && fareRulesEmpty() && isSeatMapEmpty() && isFastTrackEmpty();

module.exports = createWidgetFactory({
    el: $('.ancillaries_sidebar_summary'),
    name: 'ancillaries_summary',
    viewClass: BaseView.extend({
        initialize() {
            ShoppingCart.subscribe(this.onChange.bind(this));
            this.render();
        },

        onChange() {
            this.render();
        },

        render() {
            this.$el.html(this.templates.default({
                keys: this.keys,
                isEmpty: isEmpty(),
                insurances: [
                    ...getInsurances(),
                    ...getFareRules(),
                ],
                serviceOptions: getServiceOptions(),
                seats: getSeatMapQuantity(),
                fastTrack: getFastTrack(),
            }));
        },
    }),
});
